<template>
	<div class="routes-item-box" v-if="list && list.length>0">
		<div class="logo-box">
			<img src="@/assets/img/logo.png" alt="" srcset="" class="logo">
			<img src="@/assets/img/logo1.png" alt="" srcset="" class="logo1">
		</div>
		<div  class="lg-flex sm-block">
			<div class="routes-item-list" v-if="item.meta.isShow" :data-i="'iel'+index" v-for="(item,index) in list" :key="index">
				<template v-if="item.name">
					<div v-if="item.children" class="parent-el" @click="setActiveItem(item)">
						<router-link :to="item.path">
							<div class="title">
								{{item.meta.title}}
								<!-- <i class="text-line-x" v-if="activeNavItem==item.meta.value"></i> -->
								<i class="text-line-x"></i>
							</div>
						</router-link>
					</div>
					<div v-if="!item.children" class="children-el" @click="setActiveItem(item)">
						<router-link :to="item.path">
							<!-- <div class="logo-box" v-if="item.meta.value=='logo'">
								<img src="@/assets/img/logo.png" alt="" srcset="" class="logo">
								<img src="@/assets/img/logo1.png" alt="" srcset="" class="logo1">
							</div> -->
							<div class="title" v-if="item.meta.title">
								{{item.meta.title}}
								<!-- <i class="text-line-x" v-if="activeNavItem==item.meta.value"></i> -->
								<i class="text-line-x"></i>
							</div>
						</router-link>
						<div class="tel-box flex-item-center" v-if="item.meta.value=='tel'">
							<span class="tel-img"></span>
							400-0553-888
							
						</div>
					</div>
				</template>
				<menuItem v-if="item.children" :list="item.children"></menuItem>
			</div>
		</div>
		
	</div>
	
	
</template>

<script scoped>

	import { mapState,mapMutations } from 'vuex';
	export default {
		name:"menuItem",
		props:{
			list:{
				type:Array,
				default:function(){
					return [];
				},
				required: true,
				
			}
		},
		data(){
			return {
				activeNavItem:"home",
				data:[],
			}
		},
		watch: {
			$route(to, from) {
				this.activeNavItem = to.meta.value;
			},
		},
		
		computed: {
			...mapState(['homeSwiperOption'])
		},
		data() {
			return {
				activeNavItem:"home",
			}
		},
		created() {
			this.data=this.list;
		},
		computed:{
			routes(){
				return this.$router.options.routes;
			}
		},
		methods: {
			setActiveItem(item){
				this.$emit('activeMenu',item);
				this.activeNavItem=item.meta.value;
			},
		},
	}
</script>

<style scoped lang="scss">
	@import '../assets/css/media-menu.scss';
	
</style>